module.exports = __webpack_public_path__ + "static/img/YORK教室 _2.97a5200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK教室 _2.png
// module id = /e5T
// module chunks = 0